import React, { CSSProperties, useMemo, useRef } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import './grid-slider.styles.scss';

const containerStyle: CSSProperties = {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

interface GridCheckboxComponentProps extends ICellRendererParams {
    onChange?: (checked: boolean, data: any) => boolean;
    readonly?: boolean;
    style?: CSSProperties;
    hide?: boolean;
    dataId?: string;
    id: string;
}

export const GridSliderView = ({ value, onChange, data, readonly, style, hide, dataId, id }: GridCheckboxComponentProps) => {
    const inputRef = useRef<HTMLInputElement>();

    const checkboxStyle = useMemo(() => {
        return {
            cursor: readonly ? 'initial' : 'pointer',
            padding: 5,
        };
    }, []);

    const handleOnChange = (e) => {
        if (onChange) {
            const proceedWithEvent = onChange(e.target.checked, data);
            if (!proceedWithEvent) {
                e?.preventDefault();
                e.target.checked = false;
            }
        }
        e.stopPropagation();
        e.originalEvent?.stopPropagation();
    };

    if (hide) {
        return null;
    }

    return (
        <div style={containerStyle} data-test-id={dataId}>
            <input
                className="cmn-toggle-grid  cmn-toggle-grid-round-flat"
                style={{ ...checkboxStyle, ...style }}
                ref={inputRef}
                type="checkbox"
                onChange={handleOnChange}
                defaultChecked={value}
                disabled={readonly}
                id={data[id] + '_slider'}
            />
            <label htmlFor={data[id] + '_slider'}></label>
        </div>
    );
};
